import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlT3Sector } from 'src/app/common';
import { Tier3Sector } from 'src/app/models/obs/tier3sector';

@Injectable({
  providedIn: 'root'
})
export class T3sectorService {

  constructor(private http: HttpClient) { }

  create(data: Tier3Sector): Observable<Tier3Sector> {
    return this.http.post(`${urlT3Sector}/create`, data);
  }

  deleteRelationships(data: Tier3Sector[]): Observable<any> {    
    return this.http.post(`${urlT3Sector}/deleteRelationships`, data);
  }

}
